import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ForbiddenPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 2,
      }}>
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        403 – Forbidden
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        You’re logged in, but you don’t have permission to access this page.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate("/")}>
        Return to Homepage
      </Button>
    </Box>
  );
};

export default ForbiddenPage;
